<template>
  <div v-if="offline" class="bg-red-500 text-white px-4 py-2 text-center text-sm font-bold relative z-50">
    <div class="flex items-center justify-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd" />
        <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L4.95 3.95zM15.05 15.05l-4.24-4.24 4.24 4.24zM3.51 3.51l12.98 12.98" clip-rule="evenodd" /> 
      </svg>
      <span>Estás desconectado. Los cambios se guardarán y enviarán cuando vuelvas a tener conexión.</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      offline: !navigator.onLine
    }
  },
  mounted() {
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  },
  beforeUnmount() {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  },
  methods: {
    updateOnlineStatus() {
      this.offline = !navigator.onLine
    }
  }
}
</script>
